import * as React from 'react';
import Modal from 'src/components/common/Modal/Modal';
import Button from 'src/components/common/Button';
import './DeleteReturnModal.scss';
import useMobile from 'src/hooks/useMobile';

interface IProps {
  onDelete: () => void;
  onCancel: () => void;
  t?: any;
}

const DeleteReturnModal: React.FC<IProps> = ({ onCancel, onDelete, t }) => {
  const isMobile = useMobile();

  return (
    <div className="rp-delete-return-modal">
      <Modal
        handleCloseModal={onCancel}
        showClose={false}
        styles={{
          backgroundColor: 'white',
          color: 'black',
          minHeight: 'unset',
          padding: '40px',
          width: isMobile ? '95%' : ''
        }}
      >
        <i className="rpds-error rp-modal-error-icon" />
        <p className="rp-modal-title">{t('myReturns.deleteReturn')}</p>
        <p className="rp-modal-text">{t('myReturns.deleteReturnDesc')}</p>
        <div className="rp-modal-buttons-container">
          <Button
            label={(t('common.goBack') as string).toUpperCase()}
            buttonClass="secondary-button"
            action={onCancel}
            width="50%"
            height="40px"
          />
          <Button
            label={(t('common.deleteAction') as string).toUpperCase()}
            buttonClass="primary-button"
            action={onDelete}
            width="50%"
            height="40px"
          />
        </div>
      </Modal>
    </div>
  );
};

export default DeleteReturnModal;
